import React from "react";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { PROGRAM_STATUS, getSkipReasonLabel } from "constants/batchPreference";
import {
  formatStartDate,
  getBatchScheduleDayTimeLabels,
  getStartDateStatus,
} from "utils/batchPreferenceUtils";

import styles from "./BatchPreference.module.scss";

const BatchPreferencesSummary = ({ programs, onEdit, onProceed }) => {
  return (
    <div className={styles.summary}>
      <div className={styles.pageHeader}>
        <h2 className={styles.pageTitle}>Batch Preferences Completed</h2>
        <p className={styles.pageSubtitle}>
          Review your selected programs and batches before proceeding.
        </p>
      </div>

      <div className={styles.summaryList}>
        {programs.map((program) => {
          const isSkipped = program.status === PROGRAM_STATUS.SKIPPED;
          const dayTimeLabels = getBatchScheduleDayTimeLabels(
            program.decision,
          );

          return (
            <div key={program.id} className={styles.summaryCard}>
              <div className={styles.summaryHeader}>
                <div className={styles.summaryProgramMeta}>
                  <div className={styles.summaryProgramText}>
                    <h3 className={styles.summaryProgramName}>
                      {program.name}
                    </h3>
                    <span
                      className={
                        isSkipped
                          ? styles.summaryStatusSkipped
                          : styles.summaryStatusConfirmed
                      }
                    >
                      <CheckCircleIcon className={styles.summaryStatusIcon} />
                      {isSkipped ? "Skipped" : "Confirmed"}
                    </span>
                  </div>
                </div>
              </div>

              {isSkipped ? (
                <div className={styles.summarySkippedBody}>
                  <p className={styles.summarySkipReason}>
                    {getSkipReasonLabel(program.decision?.skipReasonCode)}
                  </p>
                  {program.decision?.skipReasonDetail ? (
                    <p className={styles.additionalInfo}>
                      {program.decision.skipReasonDetail}
                    </p>
                  ) : null}
                </div>
              ) : (
                <div className={styles.summaryConfirmedBody}>
                  <div className={styles.summaryBatchLabel}>
                    <CalendarMonthIcon className={styles.summaryDetailIcon} />
                    <span>{program.decision?.batchLabel || "Batch"}</span>
                  </div>

                  <div className={styles.scheduleLabelsRow}>
                    {dayTimeLabels.map((dayTimeLabel, index) => (
                      <span
                        key={`${index}-${dayTimeLabel}`}
                        className={styles.scheduleLabel}
                      >
                        <AccessTimeIcon className={styles.scheduleLabelIcon} />
                        {dayTimeLabel}
                      </span>
                    ))}
                  </div>

                  <div className={styles.summaryStartDate}>
                    <CalendarMonthIcon className={styles.summaryDetailIcon} />
                    <span>
                      {formatStartDate(program.decision?.startDate)} ·{" "}
                      {getStartDateStatus(program.decision?.startDate)}
                    </span>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className={styles.summaryActions}>
        <button
          type="button"
          className={styles.summaryEditButton}
          onClick={onEdit}
        >
          <EditOutlinedIcon className={styles.summaryEditIcon} />
          Edit
        </button>
        <button
          type="button"
          className={styles.proceedPaymentButton}
          onClick={onProceed}
        >
          Proceed To Payment
          <ArrowForwardIcon className={styles.proceedPaymentIcon} />
        </button>
      </div>
    </div>
  );
};

export default BatchPreferencesSummary;
